import PropTypes from 'prop-types';

function MMPreparedFoodsInactive({ className, width }) {
    return (
        <svg width={width} viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
            <path
                d="M1.00174 12.8941C1.00174 12.8941 1.40119 19.1037 6.256 22.0786C8.36217 23.2685 8.36217 23.2685 8.36217 23.2685C8.36217 23.2685 7.99625 25.1009 8.36217 25.1931C8.7281 25.2853 17.3818 25.6512 17.6109 25.1931C17.84 24.735 17.4265 23.2238 17.84 23.1791C18.2534 23.1344 21.3204 22.3104 23.2423 18.6902C25.1641 15.0701 25.097 12.6231 25.097 12.6231C25.097 12.6231 9.21134 7.30741 1.00174 12.8941Z"
                fill="#FFF9EA"
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M1.00172 12.8945C0.917918 14.0258 3.89002 14.8917 12.2058 15.0398C12.5047 15.0453 12.8119 15.0481 13.1248 15.0537C14.2477 15.0649 15.2812 15.0481 16.231 15.009C22.8875 14.7269 25.4434 13.2911 25.0579 12.5174C24.6166 11.6347 20.583 9.57879 11.1918 9.91958C11.1918 9.91678 1.24474 9.6151 1.00172 12.8945Z"
                fill="#FFF9EA"
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M11.5 15C12 12.5 14.1667 12.5787 15.0299 12.0843C16.0466 11.506 21.9098 0.933277 22.6165 1.00032C23.3205 1.07015 24.8157 1.25125 24.6034 1.71494C24.3912 2.17864 17.6564 11.8352 17.5 12.5C18.5 14 19 13.5 18 15"
                fill="#FFF9EA"
            />
            <path
                d="M11.5 15C12 12.5 14.1667 12.5787 15.0299 12.0843C16.0466 11.506 21.9098 0.933277 22.6165 1.00032C23.3205 1.07015 24.8157 1.25125 24.6034 1.71494C24.3912 2.17864 17.6564 11.8352 17.5 12.5C18.5 14 19 13.5 18 15C16 15.5 11.5 15 11.5 15Z"
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M3.78387 16.3555C3.78387 16.3555 4.51573 18.7354 7.17219 20.1572"
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}

export default MMPreparedFoodsInactive;

MMPreparedFoodsInactive.propTypes = {
    className: PropTypes.string,
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

MMPreparedFoodsInactive.defaultProps = {
    className: null,
    width: 28,
};
